import { useQuery } from '@hooks/reactQuery';

import { getPortalAvailableMilestones } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';
import { portalAvailableMilestonesFormatted } from '@utils/formatter';

import { IPortalAvailableMilestonesDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_AVAILABLE_MILESTONES } from '@constants/queryKeys';

interface IUseQueryPortalAvailableMilestonesReturned {
	isLoadingPortalAvailableMilestones: boolean;
	portalAvailableMilestones: IPortalAvailableMilestonesDTO[];
}

export const useQueryPortalAvailableMilestones = (projectId?: string): IUseQueryPortalAvailableMilestonesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IPortalAvailableMilestonesDTO[]>({
			queryKey: [GET_PORTAL_AVAILABLE_MILESTONES, projectId],
			queryFn: extractQueryParams(getPortalAvailableMilestones),
			select: milestones => portalAvailableMilestonesFormatted(milestones),
			enabled: [!!projectId],
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalAvailableMilestones: isLoading || isFetching,
		portalAvailableMilestones: data || [],
	};
};
